/** 烈度圈经验半径（km）：M4→10, M5→25, M6→55, M7→100 量级 */
export function estimateIntensityRadiusKm(magnitude: number): number {
  const km = 12 * Math.pow(2.2, magnitude - 4) * 0.9
  return Math.max(6, Math.min(180, Math.round(km)))
}

const EARTH_RADIUS_KM = 6371

/** 两点间大圆距离（km） */
export function haversineKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const dLat = ((lat2 - lat1) * Math.PI) / 180
  const dLon = ((lon2 - lon1) * Math.PI) / 180
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) ** 2
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.min(1, Math.sqrt(a)))
}

/** 以 (lon, lat) 为圆心生成 n 边近似圆 GeoJSON Polygon（单位 km） */
export function circlePolygon(lon: number, lat: number, radiusKm: number, segments = 48) {
  const coords: Array<[number, number]> = []
  const angularRadius = radiusKm / EARTH_RADIUS_KM
  const latRad = (lat * Math.PI) / 180
  for (let i = 0; i <= segments; i++) {
    const bearing = (i / segments) * Math.PI * 2
    const lat2 = Math.asin(
      Math.sin(latRad) * Math.cos(angularRadius) + Math.cos(latRad) * Math.sin(angularRadius) * Math.cos(bearing),
    )
    const lon2 =
      lon +
      (Math.atan2(
        Math.sin(bearing) * Math.sin(angularRadius) * Math.cos(latRad),
        Math.cos(angularRadius) - Math.sin(latRad) * Math.sin(lat2),
      ) *
        180) /
        Math.PI
    coords.push([lon2, (lat2 * 180) / Math.PI])
  }
  return {
    type: 'Feature' as const,
    properties: {},
    geometry: { type: 'Polygon' as const, coordinates: [coords] },
  }
}
